import { useFeatureFlag } from '@order/LaunchDarkly';

export const useIsExpoRouterEnabled = () => useFeatureFlag('CELS-4877-order-expo-router-enabled');
